module.exports = __webpack_public_path__ + "static/media/sample-lesson-cart.6183d6c3.png";